import { useState, useEffect } from 'react';
import {
  Typography, Container, Box, Card, CardContent, Grid, TextField, Button,
  Alert, CircularProgress, InputAdornment, Divider,
} from '@mui/material';
import { Save, Building2 } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useAuth } from '../../contexts/AuthContext';

const Settings = () => {
  const { language } = useLanguage();
  const { user } = useAuth();
  const isFr = language === 'fr';
  const currency = user?.company?.signCurrency || '$';

  const t = isFr ? {
    title: 'Paramètres', subtitle: 'Paramètres de votre hôtel',
    hotelInfo: 'Informations de l\'hôtel',
    hotelName: 'Nom de l\'hôtel', address: 'Adresse', phone: 'Téléphone',
    email: 'Email', website: 'Site web', currency: 'Devise',
    defaultRates: 'Tarifs par défaut',
    checkInTime: 'Heure check-in', checkOutTime: 'Heure check-out',
    save: 'Enregistrer', success: 'Paramètres enregistrés',
    companyName: 'Entreprise',
  } : {
    title: 'Settings', subtitle: 'Hotel settings',
    hotelInfo: 'Hotel Information',
    hotelName: 'Hotel Name', address: 'Address', phone: 'Phone',
    email: 'Email', website: 'Website', currency: 'Currency',
    defaultRates: 'Default Rates',
    checkInTime: 'Check-in Time', checkOutTime: 'Check-out Time',
    save: 'Save', success: 'Settings saved',
    companyName: 'Company',
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: '#0D3C4C' }}>{t.title}</Typography>
        <Typography variant="body1" color="text.secondary">{t.subtitle}</Typography>
      </Box>

      {/* Hotel Info (read-only from company) */}
      <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, mb: 3 }}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <Building2 size={20} color="#0D3C4C" />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>{t.hotelInfo}</Typography>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label={t.companyName} value={user?.company?.name || ''} size="small" InputProps={{ readOnly: true }} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label={t.currency} value={currency} size="small" InputProps={{ readOnly: true }} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label={t.phone} value={user?.company?.phone || user?.phone || ''} size="small" InputProps={{ readOnly: true }} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label={t.email} value={user?.email || ''} size="small" InputProps={{ readOnly: true }} />
            </Grid>
          </Grid>
          <Alert severity="info" sx={{ mt: 2 }}>
            {isFr
              ? 'Les paramètres de l\'hôtel sont liés à votre entreprise. Modifiez-les dans les paramètres généraux de votre compte.'
              : 'Hotel settings are linked to your company. Modify them in your general account settings.'}
          </Alert>
        </CardContent>
      </Card>
    </Container>
  );
};

export default Settings;
